import React, {useEffect, useState} from 'react';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Loading from '../../../common/components/Loading/Loading';
import actions from '../../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import {useHistory} from 'react-router-dom';
import './CreateAttention.scss';
import _, {at} from 'lodash';
import Modal from '../../../common/components/Modal/Modal';
import help from '../../../images/help_h.png';
import arrowBack from '../../../images/back_arrow_left_icon.svg';
import {defaultLabServicesIds} from '../../../utils/defaultLabServices';
import AttentionCard from '../AttentionCard/AttentionCard';


const CreateAttention = (props) => {
    const {
        name,
        title,
        switchOfUser,
        approveAttentionState,
        attention,
        createAttention,
        createAttentionState,
        attentionForCreate,
        cleanCreateAttentionState,
        cleanApproveAttentionState,
        cleanAttention,
        setAttentionForCreate,
        branchesProviders,
        affiliateData,
        affiliateSelected,
        attentionsSelected,
        branches,
        setAttentionsSelected,
        userInfo,
        showSidebar,
        flagAmount,
    } = props;

    const history = useHistory();

    const [amount, setAmount] = useState(0);
    const [provider, setProvider] = useState(branches?.find((branch) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
    const [branch, setBranch] = useState(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
    const [attentionsForCreate, setAttentionsForCreate] = useState(attention?.coveredByProvider);
    const [downAttention, setDownAttention] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [showHelper, setShowHelper] = useState(false);

    const [showAmount, setShowAmount] = useState(true);


    const handleNewAttention = () => {
        setShowModal(true);
    };

    const handleOnlyDefaultLabServiceSelected = () => {
        return attentionsSelected.find((attention) => defaultLabServicesIds.includes(attention.medicalServiceId)) && attentionsSelected.length === 1;
    };

    const handleHelper = () => {
        setShowHelper(!showHelper);
    };

    useEffect(() => {
        switchOfUser('Crear Atención');
        setAttentionsSelected(attentionsSelected.map((item) => item.count = 1));
        switch (userInfo.role.name) {
            case 'ADMIN':
                setProvider(branches?.find((branch) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
                setBranch(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                setShowAmount(true);
                break;
            case 'PROVIDER_ADMIN':
                setProvider(userInfo.salesforceProviderName);
                setBranch(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                setShowAmount(true);
                break;
            case 'PROVIDER_USER':
                setProvider(userInfo.salesforceProviderName);
                setBranch(userInfo.salesforceBranchName);
                setShowAmount(!flagAmount);
                break;
            default:
                break;
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (userInfo.role.name === 'PROVIDER_USER') {
            setShowAmount(!flagAmount);
        }
    }, [flagAmount, userInfo.role.name]);

    useEffect(() => {
        if (attention) {
            let sum = 0;
            const list = attention?.coveredByProvider?.filter((att) => !(attention?.notCoveredByProvider?.some((x) => x.medicalServiceId === att.medicalServiceId)));
            list.map((att) => {
                sum += att.needsToPay;
            });
            setAmount(sum);
            // The selected ones are the ones used to calculate the total amount
            setAttentionsSelected(
                list,
            );
            // The created ones are the ones used to show to the user in the grid
            setAttentionsForCreate(list);
        }
    }, [approveAttentionState.success, attention]);

    useEffect(() => {
        // setShowAmount(!flagAmount);
        if (createAttentionState.success) {
            cleanCreateAttentionState();
            cleanApproveAttentionState();
            cleanAttention();
            history.push('newMedicalService');
        }
        // eslint-disable-next-line
    }, [createAttentionState.success]);

    const handleBack = (e) => {
        e.preventDefault();
        history.goBack();
    };

    const createMultiple = () => {
        setShowModal(false);

        const newArray = attentionsSelected.flatMap((objeto) =>
            Array.from({length: objeto.count ? objeto.count : 1}, () => ({...objeto})),
        );

        const body = {
            affiliateNumber: attentionForCreate.affiliateNumber,
            document: attentionForCreate.document,
            medicalServicesWithPreferentialFee: newArray.map((x, index) => {
                const result = {
                    id: x.medicalServiceId,
                    preferentialFee: x?.needInputAmount && x.amount ? x.amount : null,
                };
                return x?.needInputAmount ? result : _.omit(result, ['preferentialFee']);
            }),
            salesforceBranchId: attentionForCreate.salesforceBranchId,
        };
        setAttentionForCreate(body);
        createAttention(_.omit(body, ['salesforceProviderId']));
    };

    const deleteAttention = (attentionId) => {
        setDownAttention([...downAttention, attentionsForCreate.find((att) => att.medicalServiceId === attentionId)]);
        setAttentionsSelected(attentionsSelected.filter((att) => att.medicalServiceId !== attentionId));
        reCalcAmount(attentionsSelected.filter((att) => att.medicalServiceId !== attentionId));
    };

    const addAttention = (attentionId) => {
        setAttentionsSelected([...attentionsSelected, downAttention.find((att) => att.medicalServiceId === attentionId)]);
        setDownAttention(downAttention.filter((att) => att.medicalServiceId !== attentionId));
        reCalcAmount([...attentionsSelected, downAttention.find((att) => att.medicalServiceId === attentionId)]);
    };

    const handleChangeCount = (attentionId, count) => {
        reCalcAmount(attentionsSelected.map((item) =>
            item.medicalServiceId === attentionId ? {...item, count: count} : item));
        setAttentionsSelected(attentionsSelected.map((item) =>
            item.medicalServiceId === attentionId ? {...item, count: count} : item));
        setAttentionsForCreate(attentionsForCreate.map((item) =>
            item.medicalServiceId === attentionId ? {...item, count: count} : item));
    };

    const reCalcAmount = (attentions) => {
        let sum = 0;
        attentions.map((att) => {
            if (att.count > 1 ) {
                for (let i= 0; i< att.count; i++) {
                    sum += att.amount || att.needsToPay;
                }
            } else {
                sum += att.amount || att.needsToPay;
            }
        });
        setAmount(sum ? sum : 0);
    };

    const rederError = () => {
        if (attention.errorMessage) {
            if (!attention.coveredByProvider) {
                return (
                    <div>
                        <CustomAlert text={attention.errorMessage} severity='error' customText={true}/>
                        {attention.notCoveredByProvider.map((x) =>
                            // eslint-disable-next-line react/jsx-key
                            <CustomAlert text={x.medicalServiceName} severity='error' customText={true} isList={true}/>,
                        )
                        }
                        <div style={{textAlign: 'center', marginBottom: '20px'}}>
                            <Ebutton classNameButton="eu-btn"
                                     onClick={() => history.goBack()} text="Realizar nueva consulta"/>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div>
                        <div>
                            <CustomAlert text={attention.errorMessage} severity='error' customText={true}/>
                            {attention.notCoveredByProvider.map((x) =>
                                // eslint-disable-next-line react/jsx-key
                                <CustomAlert text={x.medicalServiceName} severity='error' customText={true}
                                             isList={true}/>,
                            )
                            }
                        </div>
                    </div>
                );
            }
        }
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <div className="ul-div-header-section">
                <button onClick={handleBack}>
                    <img
                        src={arrowBack}
                        alt={'<'}
                    />
                </button>
                <p className="ul-p-name">{name}</p>
            </div>
            <div className="ul-div-affiliate-container">
                <div className="ul-div-info-container">
                    <div>
                        <p className="ul-p-title">DATOS DEL PACIENTE</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className="ul-div-affiliate-data-container">
                        <div className="ul-div-affiliate-data">
                            <h3>NOMBRE</h3>
                            <p>
                                {
                                    affiliateData[0].fullName
                                }
                            </p>
                        </div>
                        <div className="ul-div-affiliate-data">
                            <h3>{affiliateSelected.searchTag === 'document' ? 'DOCUMENTO' : 'CREDENCIAL'}</h3>
                            <p>
                                {
                                    affiliateSelected.searchTag === 'document' ? affiliateData[0].documentNumber : affiliateData[0].affiliateNumber
                                }
                            </p>
                        </div>
                    </div>
                </div>
                <div className="ul-div-info-container">
                    <div>
                        <p className="ul-p-title">DATOS DEL PRESTADOR</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className="ul-div-affiliate-data-container">
                        <div className="ul-div-affiliate-data">
                            <h3>PRESTADOR</h3>
                            <p>
                                {provider}
                            </p>
                        </div>
                        <div className="ul-div-affiliate-data">
                            <h3>SEDE</h3>
                            <p>
                                {branch}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="ul-div-info-container">
                    <div>
                        <p className="ul-p-title">DATOS DEL SERVICIO</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className="ul-div-affiliate-data-container">
                        <div className="ul-div-affiliate-data"
                             style={{width: '100%', maxHeight: '100px', overflowX: 'auto'}}>
                            <h3>NOMBRE</h3>
                            {approveAttentionState.success ? attentionsSelected && attentionsSelected.map((att) => (
                                // eslint-disable-next-line react/jsx-key
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    marginBottom: 1,
                                }}>
                                    <p>
                                        {att.medicalServiceName || att.medicalServiceId} {att.count && `X ${att.count}`}
                                    </p>
                                </div>

                            )): <></>}
                        </div>
                    </div>
                </div>

            </div>
            <div className="ul-div-section">
                {approveAttentionState.success && rederError()}
                {approveAttentionState.success && !createAttentionState.loading && attentionsForCreate &&
                    <div>
                        <div className="ul-div-sect-header">
                            <div>
                                <p className="ul-p-title">{title.toUpperCase()} <img src={help} alt={'help'} style={{
                                    maxHeight: '20px',
                                    justifySelf: 'center',
                                    alignSelf: 'center',
                                }} onClick={() => handleHelper()}></img></p>
                                <hr id="id-hr"/>
                            </div>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginRight: 5,
                            alignItems: 'center',
                        }}>
                            <div>
                                <Ebutton
                                    classNameButton="ul-btn create-btn"
                                    type="button"
                                    onClick={() => handleNewAttention()}
                                    text="Registrar"
                                    disabled={attentionsSelected?.length === 0 || handleOnlyDefaultLabServiceSelected()}
                                />
                            </div>
                            <div>
                                {showAmount &&
                                    <text className="vu-name amount">Total a abonar por afiliado: ${amount}</text>}
                            </div>
                        </div>
                    </div>
                }

                <div className="ul-div-sect-table">
                    {approveAttentionState.success ?
                        (
                            <div>
                                {createAttentionState.loading ?
                                    <div className="mb-50">
                                        <Loading/>
                                    </div> :
                                    <div className="grid-container">
                                        {attentionsForCreate?.map((att) => (renderAttention(att, createAttention, attentionForCreate,
                                            createAttentionState, amount, setAmount, reCalcAmount, deleteAttention, addAttention, showAmount, handleChangeCount, attentionsSelected.find((item) => item.medicalServiceId === att.medicalServiceId))))}
                                    </div>
                                }
                            </div>
                        ) :
                        approveAttentionState.loading ?
                            <div className="mb-50">
                                <Loading/>
                            </div> :
                            approveAttentionState.error &&
                            <div>
                                <CustomAlert text={approveAttentionState.error.message} severity='error'
                                             customText={true}/>
                                <div style={{textAlign: 'center', marginBottom: '20px'}}>
                                    <Ebutton classNameButton="eu-btn"
                                             onClick={() => history.push('newMedicalService')}
                                             text="Realizar nueva consulta"/>
                                </div>
                            </div>
                    }
                </div>

            </div>
            {showModal && (
                <Modal
                    showModal={showModal}
                    handleClose={() => setShowModal(false)}
                    handleClick={() => createMultiple()}
                    modalText={`¿SEGURO QUE DESEA CREAR ${attentionsSelected.flatMap((objeto) =>
                        Array.from({length: objeto.count ? objeto.count : 1}, () => ({...objeto})),
                    ).length} ${attentionsSelected.length > 1 ? `ATENCIONES` : `ATENCION`}?`}
                />
            )}
            {showHelper && (
                <Modal
                    showModal={showHelper}
                    handleClose={() => setShowHelper(false)}
                    handleClick={() => handleHelper()}
                    modalText={`Finalice el proceso de carga seleccionando “registrar”`}
                />
            )}
        </div>
    );
};

const renderAttention =
    (attention, createAttention, attentionForCreate, createAttentionState, amount, setAmount, reCalcAmount, deleteAttention, addAttention, showAmount, handleChangeCount, disable) => {
        // todo: add handler status medicalServiceNotCoveredByProvider
        return (
            <AttentionCard attention={attention} attentionForCreate={attentionForCreate}
                           deleteAttention={deleteAttention} addAttention={addAttention} reCalcAmount={reCalcAmount}
                           disable={disable} handleChangeCount={handleChangeCount} showAmount={showAmount}
                           editable={!defaultLabServicesIds.find((id) => id === attention.medicalServiceId)}/>
        );
    };

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    approveAttentionState: state.home.approveAttentionState,
    attention: state.home.attention,
    affiliateSelected: state.home.affiliateSelected,
    affiliateData: state.home.affiliates,
    createAttentionState: state.home.createAttentionState,
    attentionForCreate: state.home.attentionForCreate,
    branchesProviders: state.home.branchesProviders,
    attentionsSelected: state.home.attentionsSelected,
    branches: state.home.branches,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
    flagAmount: state.home.flagAmount,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    createAttention: (body) => dispatch(actions.home.createAttentionRequest(body)),
    cleanCreateAttentionState: () => dispatch(actions.home.cleanCreateAttentionState()),
    cleanApproveAttentionState: () => dispatch(actions.home.cleanApproveAttentionState()),
    cleanAttention: () => dispatch(actions.home.cleanAttention()),
    setAttentionForCreate: (attention) => dispatch(actions.home.setAttentionForCreate(attention)),
    setAttentionsSelected: (attentionsSelected) => dispatch(actions.home.setAttentionsSelected(attentionsSelected)),
});

CreateAttention.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    approveAttentionState: PropTypes.object,
    attention: PropTypes.object,
    createAttentionState: PropTypes.object,
    attentionForCreate: PropTypes.object,
    flagAmount: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAttention);

